import { memo } from 'react';

type SyringeIconProps = {
  className?: string;
};

const Syringe = ({ className }: SyringeIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18 2L22 6"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7L20 4"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 9L8.69995 19.3C7.69995 20.3 6.19995 20.3 5.29995 19.3L4.69995 18.7C3.69995 17.7 3.69995 16.2 4.69995 15.3L15 5"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11L13 15"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19L2 22"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 4L20 10"
        stroke="currentColor"
        strokeWidth="0.999783"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SyringeIcon = memo(Syringe);
SyringeIcon.displayName = 'SyringeIcon';
